import { render, staticRenderFns } from "./ConfirmDenied.vue?vue&type=template&id=187f6dd4"
import script from "./ConfirmDenied.vue?vue&type=script&lang=js"
export * from "./ConfirmDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports